import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Avatar from '@deprecated-ui/common/Avatar';
import color from '@deprecated-ui/_style/color';

const LoggedInInvitationWrapper = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
})`
  width: 100%;
  height: calc(100vh - 100px);
`;

const GuestInvitationWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  padding-top: 110px;
  background: #F5F5F6;
`;

const GuestInvitationContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  direction: 'column',
})`
  background: ${color.light};
  width: 100%;
  margin: 50px 10px;
  height: 648px;
  border-radius: 4px;
`;

const GroupInvitationWrapper = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
  direction: 'column',
})`
  width: 400px;
  height: 365px;
  background: ${color.light};
  border-radius: 4px;
  padding: 20px;
`;

const NoGroupAvatar = styled.span`
  display: block;
  width: 68px;
  height: 68px;
  line-height: 68px;
  font-size: 28px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  border-radius: 100%;
  overflow: hidden;
  background: #ebf8f3;
  color: #00ab6b;
  i {
    font-style: normal;
  }
`;

const GroupAvatarContainer = styled(Avatar)`
  margin-bottom: 16px;
  img {
    width: 68px;
    height: 68px;
  }
`;

const MemberAvatarContainer = styled(Avatar)`
  img {
    width: 50px;
    height: 50px;
  }
`;

const RestMember = styled(Flex)`
  padding: 4px 6px 0 6px;
  i {
    width: 50px;
    height: 50px;
    left: 7px;
    top: 4px;
    background: #f7f7f7;
    border: 1px solid #ededed;
    box-sizing: border-box;
    display: block;
    border-radius: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #b5b5b5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const InvitationFooterButton = styled.button`
  margin-top: 40px;
  border: 1px solid #ededed;
  box-sizing: border-box;
  width: 360px;
  height: 44px;
  background: ${color.light};
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: ${color.primary};
  cursor: pointer;
`;

const GuestJoinGroupButton = styled.a`
  padding: 12px 20px;
  width: 166px;
  height: 44px;
  background: ${color.primary};
  border-radius: 4px;
  color: white;
  border: none;
  margin-top: 40px;
  line-height: 19px;
  text-align: center;
  cursor: pointer;

  :hover {
    color: ${color.light};
  }
`;

export {
  LoggedInInvitationWrapper,
  GroupInvitationWrapper,
  GroupAvatarContainer,
  NoGroupAvatar,
  MemberAvatarContainer,
  InvitationFooterButton,
  GuestInvitationWrapper,
  GuestInvitationContainer,
  GuestJoinGroupButton,
  RestMember,
};
